import { Dropdown, MenuProps } from 'antd'

type Props = {
  options?: MenuProps['items']
}

export const TableActions = ({ options = [] }: Props) => {
  return (
    <Dropdown.Button
      trigger={['click']}
      menu={{ items: options }}
      buttonsRender={(btns) => [null, btns[1]]}
    />
  )
}
